module.exports = "Atoms are used smallest elements of the design systems. They are the building blocks."